import { ManualShipmentRuleResponse } from '@/api/services/common.dto'
import { EntityStatusState } from '@/store/root/root-store.model'

export interface ManualShipmentModalSample {
    label: string
    caseId: number
    sampleId: number
}

export interface ManualShipmentModalPortion extends ManualShipmentModalSample {
    portionId?: number
}

export interface ManualShipmentModalSubportion extends ManualShipmentModalPortion{
    subportionId?: number
}

export type ManualShipmentModalSelectedElement = ManualShipmentModalSample & ManualShipmentModalPortion & ManualShipmentModalSubportion

export interface ManualShipmentModalState {
    samples: ManualShipmentModalSample[]
    portions: ManualShipmentModalPortion[]
    subportions: ManualShipmentModalSubportion[]
    compatibleManualShipmentRules: ManualShipmentRuleResponse[]
    selectedElements: ManualShipmentModalSelectedElement[]
    entityStates: EntityStatusState[]
}
export const initialManualShipmentModalState =
    (): ManualShipmentModalState => ({
        samples: [],
        portions: [],
        subportions: [],
        compatibleManualShipmentRules: [],
        selectedElements: [],
        entityStates: []
    })
